module.exports = __webpack_public_path__ + "img/Roçadeira manual.5bc7d558.webp";